// Gate temporaneo per pagine in attesa di approvazione.
//
// Perche' per ID e non per username: l'AuthContext (JWTContext) NON carica il
// profilo all'init (`user = {}`), quindi `useAuth().user.username` e' inaffidabile
// dopo un reload. Il segnale affidabile lato client e' il payload del JWT, che
// contiene `sub` = user id. summuscode0 = id 710 (id stabile: il DB locale e' un
// dump di prod, gli id coincidono).

export const SUMMUSCODE0_ID = "710";

/** User id corrente dal payload del JWT in localStorage (o null). */
export function getCurrentUserId() {
  try {
    if (typeof window === "undefined") return null;
    const token = window.localStorage.getItem("accessToken");
    if (!token) return null;
    const part = token.split(".")[1];
    if (!part) return null;
    const json = JSON.parse(atob(part.replace(/-/g, "+").replace(/_/g, "/")));
    return json && json.sub != null ? String(json.sub) : null;
  } catch (e) {
    return null;
  }
}

/** true se l'utente loggato e' summuscode0. */
export function isSummusCode0() {
  return getCurrentUserId() === SUMMUSCODE0_ID;
}
